import styled from '@emotion/styled';
import { media } from '@portalterreno/react-ui-core/Grid';

const StyledWrapper = styled.div({
  marginBottom: 12,
  [media('lg')]: {
    marginTop: 6,
    marginBottom: 15
  }
});

export default StyledWrapper;
